// import React from 'react';
import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
// import { Gradient } from '../gradientTwo';
import { GradientFour } from '../gradientFour';
import CustomButton from './CustomButton';
const BannerFour = () => {
      const navigate = useNavigate();
      useEffect(() => {
        // Initialize the gradient after the component mounts
        const gradient = new GradientFour();
        gradient.initGradient("#gradient-canvas-four");
      }, []);
  return (
      <>
        <div className="voloto-banner " >
        
          <canvas
            id="gradient-canvas-four"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              "--gradient-color-1": "#3E005D",
              "--gradient-color-3": "#78258A",
              "--gradient-color-2": "#E056FD",
            }}
          />
    
          <div className="container position-relative h-85" >
          <Row className='h-100'>
              <Col lg={12} className='h-100 d-flex align-items-center'>
              <div className='volto-banner-header'>
                <h1 className='banner-two-text'>Your GCC in India</h1>
                <h3>End‑to‑end support </h3>
              
                <p className='mt-4 mb-5 volto-margin'>Site selection & legal/OP compliance<br />Infrastructure, technology & workforce planning <br />Hiring strategy, onboarding & local team build‑out</p>
                
                <div className='mt-5 volto-banner-btn-home'><CustomButton buttonText='Let’s Connect' buttonType='bannerBtn' onClick={() => navigate("/contact")} arrow /></div>
                
                </div>
              </Col>
            </Row>
            <div className="">
              {/* Style tag for inline keyframes */}
              <style>
                {`
                  @keyframes colorCycle {
                    0% {
                      color: black;
                    }
                    25% {
                      color: black;
                    }
                    50% {
                      color: white;
                    }
                    75% {
                      color: white;
                    }
                    100% {
                      color: black;
                    }
                  }
                  .color-animate {
                    animation: colorCycle 4s linear infinite;
                  }
                `}
              </style>
             
            </div>
          </div>
          
        </div>
    
    
        </>
  )
}

export default BannerFour